module.exports = __webpack_public_path__ + "assets/img/swiper-2.fbe2328e.jpg";